import axios from 'axios';

import baseUrl from './base';

export const apiLucree = axios.create({
	baseURL: baseUrl.lucree,
});

export const apiHierarquia = axios.create({
	baseURL: baseUrl.hierarquia,
});

export const apiConciliacao = axios.create({
	baseURL: `${baseUrl.conciliacao}/api`,
});

export const apiLiquidacao = axios.create({
	baseURL: `${baseUrl.liquidacao}/api/lucree/`,
});

export const apiComercial = axios.create({
	baseURL: baseUrl.comercial,
});

export const apiKYC = axios.create({
	baseURL: baseUrl.kyc,
});

export const apiTransacao = axios.create({
	baseURL: baseUrl.transacao,
});

export const apiGatewayPagamentos = axios.create({
	baseURL: baseUrl.gatewayPagamentos,
});

export const apiGrupos = axios.create({
	baseURL: baseUrl.grupos,
});

export const apiSplit = axios.create({
	baseURL: baseUrl.split,
});

export const apiExtrato = axios.create({
	baseURL: baseUrl.extrato,
});

export const apiSaldo = axios.create({
	baseURL: baseUrl.saldo,
});

export const apiPedido = axios.create({
	baseURL: baseUrl.pedido,
});

export const apiSolicitacao = axios.create({
	baseURL: baseUrl.solicitacao,
});

export const apiResumo = axios.create({
	baseURL: baseUrl.resumo,
})

export const apiConsultaRevendas = axios.create({
	baseURL: baseUrl.consultaRevendas,
})

export const apiLancamentos = axios.create({
	baseURL: baseUrl.lancamentos,
})

export const apiMensageria = axios.create({
	baseURL: baseUrl.mensageria,
})

export const apiPGM = axios.create({
	baseURL: baseUrl.pgm,
})

export const apiOnboarding = axios.create({
	baseURL: baseUrl.onboarding,
})


export const apiProgramaMercado= axios.create({
	baseURL: baseUrl.programaMercado,
})

export const apiPlanos = axios.create({
	baseURL: baseUrl.planos,
})

export const apiSimulador = axios.create({
	baseURL: `${baseUrl.simulador}/api`,
});

export const apiToken = axios.create({
	baseURL: `${baseUrl.token}`,
});
